import ls from 'local-storage';
import { COMMON_LOCAL_STORAGE_CACHE_KEY } from '../constants/localStorageConstants';
import { validateDateIsAfterToday } from '../utils/dateUtils';
import { setRequestAction } from '../ducks/requestDuck';

const loadCommonCacheThunk = () => (dispatch) => {
  const commonCache = ls.get(COMMON_LOCAL_STORAGE_CACHE_KEY);
  if (!commonCache) {
    return;
  }
  const {
    startDate,
    endDate,
    from,
    to,
  } = commonCache;

  dispatch(
    setRequestAction(
      {
        startDate: validateDateIsAfterToday(startDate),
        endDate: validateDateIsAfterToday(endDate),
        ...from && {
          startLocation: {
            id: from.id,
            name: from.label,
            label: from.label,
            airportCode: from.airportCode,
            type: from.type,
          },
        },
        ...to && {
          endLocation: {
            id: to.id,
            name: to.label,
            label: to.label,
            airportCode: to.airportCode,
            type: to.type,
          },
        },
      }
    )
  );
};

export default loadCommonCacheThunk;
